import { EmoticonKissIcon } from './EmoticonKissIcon';

/**
 * author: Michael Irigoyen
 * id 01F0C520-7626-4BA6-A678-1EAB14AE2C1B
 * name emoticon-kiss
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-kiss.svg
 * tags
 * - Emoji 
 */
export const FaceKissIcon = EmoticonKissIcon;
export default FaceKissIcon